import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from '../services/user-store.service';

/** Solo el mail del super panel entra. El resto vuelve al login. */
export const superpanelGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!userStore.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (userStore.isSuper()) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
